import { Redirect, Switch, useRouteMatch } from 'react-router';
import { DRAWER_MODE, SideDrawer } from 'components';
import { FORM_MODES } from 'modules/campaigns/config';
import { LayerRoute } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/components/LayerRoute/LayerRoute';
import { useMultiLayerDrawerEnabled } from 'modules/taboola-common-frontend-modules/multi-layer-drawer/hooks/useMultiLayerDrawerEnabled';
import { PATH_TO_ENTITY_MAP, PUSH_API_EDIT_ROUTE_PATH, PUSH_API_ROUTE_PATH } from '../../config';
import { PushApiEditorPage } from '../../pages/PushApiEditorPage';

export const PushApiEditDrawer = ({ onCancel }) => {
    const { params: { mode, entity: entityParam } = {} } = useRouteMatch(PUSH_API_EDIT_ROUTE_PATH) || {};
    const entity = PATH_TO_ENTITY_MAP[entityParam];
    const isOpen = entity && mode && mode !== FORM_MODES.CREATE;

    const isMultiLayerDrawerEnabled = useMultiLayerDrawerEnabled();

    if (isMultiLayerDrawerEnabled) {
        return null;
    }

    return (
        <SideDrawer openDrawer={isOpen} onClose={onCancel} drawerMode={DRAWER_MODE.LARGE}>
            {close => (
                <Switch>
                    <LayerRoute
                        exact
                        path={PUSH_API_EDIT_ROUTE_PATH}
                        render={props => <PushApiEditorPage {...props} onCancel={close} />}
                    />
                    <Redirect to={PUSH_API_ROUTE_PATH} />
                </Switch>
            )}
        </SideDrawer>
    );
};
